import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './styles.module.styl';

const BooleanFeedbackButton = ({ isPositive, isActive, isDisabled, handleClick, iconCode }) => (
  <button
    className={cx(
      styles.button,
      isPositive ? styles.buttonYes : styles.buttonNo,
      { [styles.active]: isActive },
      'btn',
      'btn-transparent',
      'btn-sm'
    )}
    disabled={isDisabled}
    onClick={handleClick}
  >
    <span className={cx(styles.buttonIcon, 'btn-icon', `icon-budicon-${iconCode}`)} />
    {isPositive ? 'Yes' : 'No'}
  </button>
);

BooleanFeedbackButton.defaultProps = {
  isPositive: false
};

BooleanFeedbackButton.propTypes = {
  isPositive: PropTypes.bool,
  isActive: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  iconCode: PropTypes.string.isRequired
};

export default BooleanFeedbackButton;
